import { useState } from 'react'
import useSettings from "../../hooks/Settings.jsx"
import PremiumContainer from "../../components/common/PremiumContainer.jsx"
import PageHeader from "../../components/layout/PageHeader.jsx"
import SelectableGrid from "../../components/common/SelectableGrid.jsx"
import { useFirestoreOrderBy, useFirestore } from "../../firebase/useFirestore"
import AnalysisActivityCard from "../../components/analysis/AnalysisActivityCard.jsx"
import AnalysisEffectCard from "../../components/analysis/AnalysisEffectCard.jsx"
import AnalysisResearchCard from "../../components/analysis/AnalysisResearchCard.jsx"

const TABS = [
    { id: 'activiteiten', label: 'Activiteiten' },
    { id: 'effecten', label: 'Effecten' },
    { id: 'onderzoeken', label: 'Onderzoeken' },
]

const Analysis = () => {
    // State
    const [activeTab, setActiveTab] = useState('activiteiten')

    // Hooks
    const settings = useSettings()
    const subscription = settings.subscription
    const personasEnabled = settings.personasOn === 'flex'

    // Firestore — soft-deleted docs (Deleted: true, ADR-008) stay in the
    // collection, so every list must filter them out client-side.
    const activities = (useFirestoreOrderBy('Activities', 'Position', 'asc') || []).filter((activity) => !activity.Deleted)
    const effects = (useFirestoreOrderBy('OutputEffects', 'Position', 'asc') || []).filter((effect) => !effect.Deleted)
    const researches = (useFirestoreOrderBy('Research', 'Position', 'asc') || []).filter((research) => !research.Deleted)
    // Personas loaded once at the page level — passed down to each card so we
    // don't open N parallel `onSnapshot` listeners on the Analyse grid.
    // All statuses — the persona filter chip narrows by status itself.
    const personas = useFirestore('Personas')

    const renderTabContent = () => {
        switch (activeTab) {
            case 'activiteiten':
                return (
                    <div className="analysis-cards-grid">
                        {activities && activities.length > 0
                            ? activities.map(activity => (
                                <AnalysisActivityCard
                                    key={activity.ID}
                                    activity={activity}
                                    personas={personas}
                                    personasEnabled={personasEnabled}
                                    showDeepAnalysis
                                />
                            ))
                            : <p className="analysis-tab-placeholder">Geen activiteiten gevonden</p>
                        }
                    </div>
                )
            case 'effecten':
                return (
                    <div className="analysis-cards-grid">
                        {effects && effects.length > 0
                            ? effects.map(effect => (
                                <AnalysisEffectCard
                                    key={effect.ID}
                                    effect={effect}
                                    personas={personas}
                                    personasEnabled={personasEnabled}
                                    showDeepAnalysis
                                />
                            ))
                            : <p className="analysis-tab-placeholder">Geen effecten gevonden</p>
                        }
                    </div>
                )
            case 'onderzoeken':
                return (
                    <div className="analysis-cards-grid">
                        {researches && researches.length > 0
                            ? researches.map(research => (
                                <AnalysisResearchCard
                                    key={research.ID}
                                    research={research}
                                    personas={personas}
                                    personasEnabled={personasEnabled}
                                    showDeepAnalysis
                                />
                            ))
                            : <p className="analysis-tab-placeholder">Geen onderzoeken gevonden</p>
                        }
                    </div>
                )
            default:
                return null
        }
    }

    return (
        <div className="main">
            <div className="main-container">
                <PageHeader
                    heading={'Analyseren'}
                    description={'Hier kun je activiteiten, outputs, effecten en onderzoeken analyseren.'}
                    AI={false}
                />
                {subscription === 'free'
                    ? <PremiumContainer text='Met analyses kun je diepgaande (AI) analyses uitvoeren op je resultaten en voortgang.' />
                    : <>
                        <SelectableGrid
                            items={TABS}
                            getId={(tab) => tab.id}
                            getLabel={(tab) => tab.label}
                            selectedId={activeTab}
                            onClick={setActiveTab}
                        />
                        {renderTabContent()}
                    </>
                }
            </div>
        </div>
    )
}

export default Analysis
